import { render } from "./manga.vue?vue&type=template&id=64f895d4&scoped=true&ts=true"
import script from "./manga.vue?vue&type=script&setup=true&lang=ts"
export * from "./manga.vue?vue&type=script&setup=true&lang=ts"

import "./manga.vue?vue&type=style&index=0&id=64f895d4&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f895d4"],['__file',"src/components/manga.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64f895d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64f895d4', __exports__)) {
    console.log('reload')
    api.reload('64f895d4', __exports__)
  }
  
  module.hot.accept("./manga.vue?vue&type=template&id=64f895d4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('64f895d4', render)
  })

}


export default __exports__